// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type ReviewScopeChangesCard_IncomingUpdateFragment = { __typename?: 'BidPackageIncomingUpdate', id: string, source: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined } };

export const ReviewScopeChangesCard_IncomingUpdateFragmentDoc = gql`
    fragment ReviewScopeChangesCard_IncomingUpdate on BidPackageIncomingUpdate {
  id
  source {
    id
    version
  }
}
    `;